import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { MobileNav } from "./MobileNav";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/** 已登录布局：桌面侧栏 / 手机底栏 */
export function AppShell() {
  const { user } = useAuth();
  const location = useLocation();
  const showWizardBanner =
    Boolean(user?.wizard) && location.pathname !== "/wizard";

  return (
    <div className="flex h-full min-h-0">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        {showWizardBanner ? (
          <div className="flex items-center justify-between gap-3 border-b border-brand/30 bg-brand-muted px-4 py-2 text-[12px] text-brand">
            <span>初始配置尚未完成</span>
            <Link to="/wizard" className="font-medium underline-offset-2 hover:underline">
              继续向导
            </Link>
          </div>
        ) : null}
        <main className="min-h-0 flex-1 overflow-auto p-4 pb-[calc(5.5rem+env(safe-area-inset-bottom))] sm:p-5 md:pb-5">
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
